export default "__VITE_ASSET__Bo7e0CvA__"